


























































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import AddressSelect from '@/components/AddressSelect.vue';

import { Inquiry, yun } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import CspDialog from '@/components/CspDialog.vue';
import { enums } from '@/common/enums';
import ImageSwiper from './components/ImageSwiper.vue';

import { upload } from '../../common/util/ossUploadService';
import ImagesUploadorder from '@/components/ImagesUploadorder.vue';
import { formRules } from '@/common/util/validator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';

import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        ImageSwiper,
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        AddressSelect,
        ButtonPanel,
        CspDialog,
        DataPanel,
        ImagesUploadorder,
        PageDescribe,
    },
})
export default class InquiryDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = {};
    public goodsUnitType = enums.goodsUnitTypeNum;
    public freightUnitType = enums.freightUnitType;
    public pricingModeType = enums.pricingModeType;
    public activeName = 'first';
    public title: string = '订单状态为待接单，支持用户在线编辑订单，支持重新、终结、删除订单';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public goodsList: any = [];
    public formData: any = {
        carrierId: '',
        carrierName: '',
        priceSource: '',
        pricingMode: '',
        freightPrice: '',
        freightUnit: '',
        goodsList: [
            {
                orderId: '',
                goodsName: '',
                quantity: '',
                unit: '',
                planQuantity: '',
                planGoodsUnit: '',
                model: '',
                remark: '',
            },
        ],
        originProvince: '',
        originCity: '',
        originCounty: '',
        arrivalProvince: '',
        arrivalCity: '',
        arrivalCounty: '',
    };
    public cars: any = [];
    public async created() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.getInquiryList();
        this.getdd();
    }
    public carLengthList: any = [];
    public vehicleTypeList: any = [];
    public detials: any = '';
    public sscar: any = '';
    public sssing: any = '';
    public async getdd() {
        // this.selectReset = true;
        // this.selectReset2 = true;
        this.carLengthList = await yun.GetDicList({ typeName: 'carLength' });
        this.vehicleTypeList = await yun.GetDicList({ typeName: 'carType' });
        // this.selectReset = false;
        // this.selectReset2 = false;
    }
    public allgrossWeight: any = 0;
    public tableData: any = [];
    public async getInquiryList() {
        this.selectReset = false;
        this.selectReset2 = false;
        let res = await yun.getOrderList({
            ids: this.$route.query.ids,
        });
        this.allgrossWeight = 0;

        let skip = 0;
        // let dd = JSON.parse(JSON.stringify(res.data))

        res.data.map((item, index) => {
            if (item.planWeight) {
                this.allgrossWeight = this.allgrossWeight + Number(item.planWeight);
            }
            item.index = skip++ + 1;
        });
        this.tableData = res.data;
        let dd = await yun.OrdergetDetaill(this.tableData[0].id);
        console.log('dddd', dd);
        this.detials = dd;

        this.SelectAddress1.province.value = this.detials.originProvince;
        this.SelectAddress1.city.value = this.detials.originCity;
        this.SelectAddress1.area.value = this.detials.originCounty;
        this.selectReset = true;
        this.SelectAddress2.province.value = this.detials.arrivalProvince;
        this.SelectAddress2.city.value = this.detials.arrivalCity;
        this.SelectAddress2.area.value = this.detials.arrivalCounty;
        this.selectReset2 = true;
        this.originProvince = this.detials.originProvinceStr;
        this.formData.originProvince = this.detials.originProvince;
        this.originCity = this.detials.originCityStr;
        this.formData.originCity = this.detials.originCity;
        this.originCounty = this.detials.originCountyStr;
        this.formData.originCounty = this.detials.originCounty;
        this.arrivalProvince = this.detials.arrivalProvinceStr;
        this.formData.arrivalProvince = this.detials.arrivalProvince;
        this.arrivalCity = this.detials.arrivalCityStr;
        this.formData.arrivalCity = this.detials.arrivalCity;
        this.arrivalCounty = this.detials.arrivalCountyStr;
        this.formData.arrivalCounty = this.detials.arrivalCounty;
        this.allcar = [];
        let inquiryCodeList = '';
        this.tableData.map((item, index) => {
            if (item.inquiryCode) {
                if (inquiryCodeList != '') {
                    inquiryCodeList = inquiryCodeList + ',' + item.inquiryCode;
                } else {
                    inquiryCodeList = inquiryCodeList + item.inquiryCode;
                }
            }
        });
        let xx = await yun.GetWinItems({ inquiryCodes: inquiryCodeList });
        console.log('xx', xx);
        let alllength: any = [];
        if (xx) {
            xx.forEach((item, index) => {
                item.quotes.map((dd) => {
                    let canPush: any = true;
                    alllength.map((dd1) => {
                        if (dd1 == dd.carLength) {
                            canPush = false;
                        }
                    });
                    if (canPush) {
                        alllength.push(dd.carLength);
                    }
                });
            });
        }
        console.log('xx1', alllength, xx.length);
        this.allcar = xx;
        this.alllength = alllength;
        if (this.alllength.length > 0 && xx.length > 0) {
            this.formData.priceSource = 1;
            this.formData.pricingMode = 1;
        }
        // .then((res) => {
        //
        // })
        // .catch((err) => {
        //     console.log('tableData', err)
        // });
    }
    async getcars() {
        let inquiryCodeList = '';
        this.allgrossWeight = 0;
        this.tableData.map((item, index) => {
            if (item.planWeight) {
                this.allgrossWeight = this.allgrossWeight + Number(item.planWeight);
            }
            if (item.inquiryCode) {
                if (inquiryCodeList != '') {
                    inquiryCodeList = inquiryCodeList + ',' + item.inquiryCode;
                } else {
                    inquiryCodeList = inquiryCodeList + item.inquiryCode;
                }
            }
        });
        let xx = await yun.GetWinItems({ inquiryCodes: inquiryCodeList });
        console.log('xx', xx);
        let alllength: any = [];
        try {
            xx.forEach((item, index) => {
                item.quotes.map((dd) => {
                    let canPush: any = true;
                    alllength.map((dd1) => {
                        if (dd1 == dd.carLength) {
                            canPush = false;
                        }
                    });
                    if (canPush) {
                        alllength.push(dd.carLength);
                    }
                });
            });
            console.log('xx1', alllength);
            this.allcar = xx;
            this.alllength = alllength;
        } catch (e) {
            this.allcar = [];
            this.alllength = [];
            this.formData.priceSource = '';
        }
    }
    public alllength: any = [];
    public allcar: any = [];
    public carrierId1 = '';
    public carrierName1 = '';
    public freightSourceChange() {
        this.formData.carrierId = '';
        this.formData.carrierName = '';
        this.formData.freightUnit = '';
        this.formData.freightPrice = '';
        this.formData.pricingMode = '';
        this.sssing = '';
        this.sscar = '';
        this.carrierChange();
        if (this.formData.priceSource == 1) {
            // this.formData.carrierId =  this.carrierId1
            // this.formData.carrierName = this.carrierName1
            this.formData.pricingMode = 1;
        }
    }
    handleClick(tab, event) {
        console.log(tab, event);
        if (tab.index == '1') {
        }
    }
    handleInput3(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
        this.allgrossWeight = e.target.value;
    }
    changss() {
        this.$nextTick();
        console.log('tableData', this.tableData);
    }
    carss(index, resd, res) {
        this.sscar = index;
        console.log('resd', resd);
        this.formData.carrierId = res.carrierId;
        this.formData.carrierName = res.carrierName;
        this.formData.freightPrice = resd.price ? resd.price : this.formData.price;
        this.formData.freightUnit = 1;
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    public carCodechange(val) {
        this.formData.carrierId = '';
    }
    public carCodeEnd() {
        console.log('cc2');
        if (!this.formData.carrierId) {
            this.formData.carrierName = '';
            this.formData.freightUnit = '';
            this.formData.freightPrice = '';
        }
    }
    back() {
        this.$router.back();
    }
    /**删除询价单 */
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    async confirmOk() {
        if (this.btt == 4) {
            let xx = [];
            this.tableData.forEach((items) => {
                xx.push({
                    orderId: items.id,
                    goodsName: '',
                    model: '',
                    quantity: '',
                    unit: '',
                });
            });
            this.formData.planWeight = this.allgrossWeight;
            this.formData.goodsList = xx;
            let res = await yun.CarrierOrder(this.formData);
            this.$message.success('发布成功!');
            this.$router.back();
        } else {
            this.$router.back();
        }
        this.dialogConfig = {
            show: false,
        };
    }
    public btt: any = 0;
    public ssid: any = '';
    ordergo() {
        console.log('formdata', this.formData);
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                this.ssid = '';
                this.btt = 4;
                this.dialogConfig = {
                    title: '发布运单',
                    show: true,
                };
                // this.$confirm('确认发布运单?', '确认发布', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning',
                // })
                //     .then( async () => {
                //         let xx = []
                //         this.tableData.forEach(items => {
                //             xx.push({
                //                 orderId: items.id,
                //                 goodsName: '',
                //                 spec: '',
                //                 quantity: '',
                //                 unit: ''
                //             })
                //         })
                //         this.formData.goodsList = xx
                //             let res = await yun.CarrierOrder(this.formData)
                //             this.$message.success('发布成功!');
                //             this.$router.back()
                //         }
                //     )
            }
        });
    }
    public $refs: {
        formData: HTMLFormElement;
        formDatas: HTMLFormElement;
        formData1: HTMLFormElement;
        address1: HTMLFormElement;
        address2: HTMLFormElement;
        formData2: HTMLFormElement;
    };
    public shipperAttachmentList: any = [];
    setImage(name, url, uid) {
        console.log('url=====>' + url);
        this.shipperAttachmentList.push({
            name: name,
            url: url,
            id: '',
        });
        this.formData.carrierAttList = this.shipperAttachmentList;
        // console.log('add-attachementUrls======>', this.shipperAttachmentList);
    }
    deleteImage(name, uid, url) {
        this.shipperAttachmentList = this.shipperAttachmentList.filter((v) => {
            return v.url !== url;
        });
        // console.log('del-attachementUrls', this.shipperAttachmentList, this.shipperAttachmentList.length);
    }
    viewInquiry(data) {
        if (this.tableData.length == 2) {
            this.ssid = '';
            this.btt = 3;
            this.dialogConfig = {
                title: '取消并单发运',
                show: true,
            };
            return;
        }
        this.tableData.splice(data.index - 1, 1);
        let skip = 0;
        this.tableData.map((item, index) => {
            item.index = skip++ + 1;
        });
        this.getcars();
    }
    public title1 = '新增车辆';
    public formData1: any = {
        carCode: '',
        carLength: '',
        carLengthInt: '',
        carType: '',
        carTypeInt: '',
        totalMass: '',
        approvedLoad: '',
        enabled: true,
        drivingLicenseImg: '',
        roadTransportCertificateImg: '',
        businessLicenseImg: '',
    };
    drivingLicenseImgs: any = [];
    roadTransportCertificateImgs: any = [];
    businessLicenseImgs: any = [];
    public dialogVisible: any = false;
    public addNew() {
        this.title = '新增车辆';
        this.drivingLicenseImgs = [];
        this.roadTransportCertificateImgs = [];
        this.businessLicenseImgs = [];
        this.formData1 = {
            carCode: '',
            carLength: '',
            carLengthInt: '',
            carType: '',
            carTypeInt: '',
            totalMass: '',
            approvedLoad: '',
            enabled: true,
            drivingLicenseImg: '',
            roadTransportCertificateImg: '',
            businessLicenseImg: '',
        };
        this.dialogVisible = true;
        this.$refs.formData1.resetFields();
    }

    public save() {
        this.$refs.formData1.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增车辆') {
                    let res = await yun.CarAdd(this.formData1);
                    this.$alert('添加成功');
                    this.dialogVisible = false;
                } else {
                    let res = await yun.CarUpdate(this.formData1);
                    this.$alert('编辑成功');
                    this.dialogVisible = false;
                }
            }
        });
    }
    clearcar() {
        let xx = ['drivingLicenseImg', 'roadTransportCertificateImg', 'businessLicenseImg'];
        xx.forEach((item) => {
            this.shipperAttachmentList.forEach((data, index) => {
                if (data.name == item) {
                    this.shipperAttachmentList.splice(index, 1);
                }
            });
        });
    }
    cleardirver() {
        let xx = ['idImg', 'driverLicenseImgs', 'qualificationCertificateImg'];
        xx.forEach((item) => {
            this.shipperAttachmentList.forEach((data, index) => {
                if (data.name == item) {
                    this.shipperAttachmentList.splice(index, 1);
                }
            });
        });
    }
    public formData2: any = {
        id: '',
        phone: '',
        name: '',
        idCode: '',
        enabled: true,
        idImg: '',
        driverLicenseImg: '',
        qualificationCertificateImg: '',
    };
    public title2 = '新增司机';
    iDImgs: any = [];
    QualificationCertificateImgs: any = [];
    driverLicenseImgs: any = [];
    carrierNameEnd() {
        if (this.formData.carrierId) {
        } else {
            this.formData.carrierName = '';
        }
    }
    carrierNamechange() {
        this.formData.carrierId = '';
    }
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.formData.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    public sssingin(data, index) {
        this.sssing = index;
        this.formData.freightPrice = data.priceValue;
        if (this.formData.pricingMode == 1) {
            this.formData.freightUnit = 1;
        } else {
            this.formData.freightUnit = 2;
        }
    }
    public SinglePriceList: any = [];
    async GetPrice() {
        this.SinglePriceList = [];
        if (!this.formData.carrierId) {
            return;
        }
        if (!this.formData.pricingMode) {
            return;
        }
        let data = {
            carrierId: this.formData.carrierId,
            priceListType: this.formData.pricingMode,
            deliveryProvince: this.originProvince,
            deliveryCity: this.originCity,
            deliveryArea: this.originCounty,
            arrivalProvince: this.arrivalProvince,
            arrivalCity: this.arrivalCity,
            arrivalArea: this.arrivalCounty,
            titleName: this.detials.carLength,
            weight: this.allgrossWeight,
        };
        let res = await yun.getSinglePriceList(data);
        this.SinglePriceList = res.priceListDetails[0].priceContent;
        this.sssing = '';
        this.formData.freightUnitPrice = '';
        // this.formData.freightUnitPrice = res.extData;
        console.log('this.SinglePriceList', this.SinglePriceList, res);
    }
    public carrierChange1(data) {
        if (this.formData.pricingMode == 2 || this.formData.pricingMode == 3) {
            this.sscar = '';
            this.sssing = '';
            this.formData.freightUnit = '';
            this.formData.freightPrice = '';
            this.GetPrice();
        }
    }
    public carrierChange() {
        this.sscar = '';
        this.sssing = '';
        this.formData.freightUnit = '';
        this.formData.freightPrice = '';
        this.GetPrice();
    }
    selectCar1(data) {
        this.formData.carrierId = data.id;
        this.GetPrice();
    }
    handleInput(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
    }
    handleInput1(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,2})?/)[0] : '';
        this.formData[index] = e.target.value;
    }
    toDetail(row, type) {
        if (row.statusStr == '待接单' || row.statusStr == '已终结') {
            this.$router.push({
                path: '/orderDetail',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        } else {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: row.id,
                    name: 'detail',
                },
            });
        }
    }
    public carLengthChange(item) {
        //this.form.platformCompanyId = item.code
        this.carLengthList.forEach((data) => {
            if (data.value == item) this.formData.needCarLengthEnumStr = data.name;
        });
    }
    public carTypeChange(item) {
        //this.form.platformCompanyId = item.code
        console.log('item', item);
        this.vehicleTypeList.forEach((data) => {
            if (data.value == item) this.formData.needVehicleTypeEnumStr = data.name;
        });
    }
    public selectReset: boolean = false;

    public selectReset2: boolean = false;
    public async updateReset() {
        this.selectReset = false;
        this.selectReset2 = false;
    }
    originProvince: any = '';
    public async getProvince(item, name) {
        this.formData.originProvince = item;
        this.originProvince = name;
        this.formData.originCity = '';
        this.originCity = '';
        this.formData.originCounty = '';
        this.originCounty = '';
        this.GetPrice();
    }
    originCity: any = '';
    public async getCityCode(item, name) {
        this.formData.originCity = item;
        this.originCity = name;
        this.formData.originCounty = '';
        this.originCounty = '';
        this.formData.originAddress = this.originProvince + this.originCity;
        console.log('addresname', this.originProvince + this.originCity);
        this.GetPrice();
    }
    public SelectAddress2: any = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };
    public SelectAddress1 = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };
    originCounty: any = '';
    public getName1(data, names, named) {
        this.formData.originAddress = data;
        if (names) {
            this.originProvince = names;
            this.originCity = named;
        }
    }
    public getName2(data, names, named) {
        console.log('2name', data, names);
        if (names) {
            this.arrivalProvince = names;
            this.arrivalCity = named;
        }
    }
    public async getAreaCode(item, name) {
        this.formData.originCounty = item;
        this.originCounty = name;
        this.GetPrice();
    }
    arrivalProvince: any = '';
    arrivalCounty: any = '';
    arrivalCity: any = '';
    public async getProvince2(item, name) {
        this.formData.arrivalProvince = item;
        this.arrivalProvince = name;
        this.formData.arrivalCity = '';
        this.arrivalCity = '';
        this.formData.arrivalCounty = '';
        this.arrivalCounty = '';
        console.log('xxxxx', item);
        this.GetPrice();
    }

    public async getCityCode2(item, name) {
        this.formData.arrivalCity = item;
        this.arrivalCity = name;
        this.formData.arrivalCounty = '';
        this.arrivalCounty = '';
        console.log('addresname', this.arrivalProvince + this.arrivalCity);
        this.GetPrice();
    }

    public async getAreaCode2(item, name) {
        this.formData.arrivalCounty = item;
        this.arrivalCounty = name;
        this.GetPrice();
    }
}
